import React from "react";
import { useI18n } from "../../i18n/I18nProvider";

const CalendarVector = () => {
  const { t } = useI18n();
  const states = t("showcase.states");
  const filters = t("rows.calendar.filters");

  const rows = [
    {
      label: states[0],
      mark: "bg-accent",
      title: t("rows.calendar.detailTitle"),
      meta: t("rows.calendar.detailMeta"),
    },
    {
      label: states[1],
      mark: "bg-lilac",
      title: `${filters[0]} · ${filters[1]}`,
      meta: filters[2],
    },
    {
      label: states[2],
      mark: "bg-sun",
      title: t("week.empty"),
      meta: "",
      empty: true,
    },
    {
      label: states[3],
      mark: "bg-hairline",
      title: t("week.chipReport"),
      meta: "",
      done: true,
    },
  ];

  return (
    <ul className="m-0 flex flex-col gap-2 rounded-stage bg-paper p-3">
      {rows.map((row) => (
        <li
          key={row.label}
          className={`flex items-center gap-3 rounded-card border px-3 py-2.5 ${
            row.empty ? "border-dashed border-hairline bg-paper" : "border-hairline bg-paper shadow-card"
          }`}
        >
          <span className={`h-8 w-1.5 shrink-0 rounded-pill ${row.mark}`} aria-hidden="true" />
          <div className="min-w-0">
            <p className="text-caption font-medium text-mid-gray">{row.label}</p>
            <p className={`truncate text-caption font-semibold ${row.done ? "text-mid-gray line-through" : "text-ink"}`}>
              {row.title}
            </p>
            {row.meta ? <p className="truncate text-caption text-mid-gray">{row.meta}</p> : null}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default CalendarVector;
